pctCookiesConfig.translations.es = {
    consentNotice: {
        description: "Las cookies son importantes para ti, influyen en tu experiencia de navegación, nos ayudan a proteger tu\n" +
            "privacidad y permiten realizar las peticiones que nos solicites a través de la web. Utilizamos cookies propias y de\n" +
            "terceros para analizar nuestros servicios y mostrarte publicidad relacionada con tus preferencias en base a un\n" +
            "perfil elaborado con tus hábitos de navegación (por ejemplo, páginas visitadas). Si consientes su instalación\n" +
            "pulsa \"Aceptar Cookies\", o también puedes configurar tus preferencias pulsando \"Configurar Cookies\". Más\n" +
            "información en nuestra <a href='/politica-de-cookies'>Política de Cookies</a>.\n",
        learnMore: 'Configurar cookies'
    },
    ok: 'Aceptar cookies'
};